module.exports = __webpack_public_path__ + "static/img/stay_informed_legally_icon.e4a70a66.png";